import angular from 'angular';

import TeamEditModalComponent from './team-edit-modal.cmpt';

export default angular
    .module('application.component.modals.component.team-edit-modal', [])
    .component(TeamEditModalComponent.selector, TeamEditModalComponent);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/team-edit-modal/index.js